import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GetUsuariosEnAPI, SetUsuarioEnAPI, GetIdiomasEnAPI, GetRolesEnAPI, ObtenerSocioEnAPI, ObtenerRedesEnAPI, GetNextAssistBODepartamentosEnAPI } from "../action/actionCreatorsRequests";
import { MSGERROR, MSGOK, traducirPagina, obtenerUsuario } from "../librerias/funciones"
import {
    SaveOutlined,
    CloseOutlined
} from '@ant-design/icons';
import { Select, Card, Drawer, Modal, Button, Form, Input, Checkbox, Row, Col, Tabs } from 'antd';

import store from '../store'
const { Option } = Select;
const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;

const FichaPerfil = ({ props, configApp }) => {
    const [textoIdioma, setTextoIdioma] = React.useState(1);
    const [rolPorDefecto, setRolPorDefecto] = React.useState(1);
    const [hayCliente, setHayCliente] = React.useState(false);
    const [tabPorDefecto, setTabPorDefecto] = React.useState("1");
    const [idiomasLocal, setIdiomasLocal] = React.useState([]);
    const [rolesLocal, setRolesLocal] = React.useState([]);
    const [passwordUsuario, setPasswordUsuario] = React.useState("");
    const [esSuperAdmin, setSsSuperAdmin] = React.useState(true);
    const [checkedListSocios, setCheckedListSocios] = React.useState([]);
    const [checkedListRedes, setCheckedListRedes] = React.useState([]);
    const [checkedListDepartamentos, setCheckedListtDepartamentos] = React.useState([]);

    const [todosLosSocios, setTodosLosSocios] = React.useState([]);
    const [todasLasRedes, setTodasLasRedes] = React.useState([]);
    const [todosLosDepartamentos, setTodosLosDepartamentos] = React.useState([]);


    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID: 0,
            NOMBRE: "",
            CORREO_RECUPERACION_PWD: "",
            CORREO_RECEPCION_PEDIDOS: "",
            CORREO_ENVIO_DOCUMENTOS: "",
            USUARIO: "",
            PWD_OLD: "",
            PWD_NEW: "",
            PWD: "",
            OBSERVACIONES: "",
            BAJA: false,
            ID_IDIOMA: "1",
            ID_ROL: !"1",
            PERMISO_VONZU: false,
            USUARIO_VONZU: "",
            PWD_VONZU: "",
            DOMINIO_VONZU: "",
            IDS_DEPARTAMENTOS: ""
        }
    )

    if (!hayCliente && props.ABRIR_FICHA) {
        setHayCliente(true);
        let accesoLicencia = obtenerUsuario();
        setSsSuperAdmin(accesoLicencia.ID_ROL === 2 ? false : true)

        if (props.ID_USUARIO !== -1) {

            GetUsuariosEnAPI(props.ID_USUARIO, "", "A", 0).then(usuario => {
                if (usuario !== undefined) {
                    if (usuario !== null && usuario.length > 0) {
                        setPayLoadLocal({
                            ID: usuario[0].ID,
                            NOMBRE: usuario[0].NOMBRE_USUARIO,
                            CORREO_RECUPERACION_PWD: usuario[0].CORREO_RECUPERACION_PWD,
                            CORREO_RECEPCION_PEDIDOS: usuario[0].CORREO_RECEPCION_PEDIDOS,
                            CORREO_ENVIO_DOCUMENTOS: usuario[0].CORREO_ENVIO_DOCUMENTOS,
                            USUARIO: usuario[0].USUARIO,
                            PWD_OLD: "",
                            PWD_NEW: "",
                            PWD: "",
                            OBSERVACIONES: usuario[0].OBSERVACIONES,
                            BAJA: usuario[0].BAJA,
                            ID_IDIOMA: usuario[0].ID_IDIOMA,
                            PERMISO_VONZU: usuario[0].PERMISO_VONZU,
                            USUARIO_VONZU: usuario[0].USUARIO_VONZU,
                            PWD_VONZU: usuario[0].PWD_VONZU,
                            DOMINIO_VONZU: usuario[0].DOMINIO_VONZU,
                            IDS_DEPARTAMENTOS: usuario[0].IDS_DEPARTAMENTOS
                        })

                        setPasswordUsuario(usuario[0].PWD)
                        setTextoIdioma(usuario[0].ID_IDIOMA)
                        setRolPorDefecto(usuario[0].ID_ROL)

                        let filtroIDSocios = usuario[0].SOCIOS.map((socio) => socio.ID_SOCIO);
                        setCheckedListSocios(filtroIDSocios)


                        // let filtroIDRedes = usuario[0].REDES.map((red) => red.ID);

                        //let filtroRedes = todasLasRedes.filter((red) => checkedListRedes.includes(`${red.ID}_${red.TIPO}`))
                        let registros = [];
                        usuario[0].REDES.map((red, i) => {
                            registros.push(`${red.ID}_${red.TIPO}`)
                        })

                        setCheckedListRedes(registros);

                        let registrosDepa = [];
                        usuario[0].DEPARTAMENTOS.map((registro, i) => {
                            registrosDepa.push(registro.ID_DEPARTAMENTO)
                        })

                        setCheckedListtDepartamentos(registrosDepa);

                    } else {
                        setPayLoadLocal(null)
                    }
                }
            })
        }


        GetIdiomasEnAPI().then(idiomas => {
            if (idiomas !== undefined) {
                if (idiomas !== null && idiomas.length > 0) {
                    setIdiomasLocal(idiomas)
                } else {
                    setIdiomasLocal(null)
                }
            }
        })



        GetRolesEnAPI().then(roles => {
            if (roles !== undefined) {
                if (roles !== null && roles.length > 0) {
                    setRolesLocal(roles)
                } else {
                    setIdiomasLocal(null)
                }
            }

        })

        ObtenerSocioEnAPI().then(socios => {
            if (socios !== undefined) {
                if (socios !== null && socios.length > 0) {
                    setTodosLosSocios(socios)
                }
            }
        })


        ObtenerRedesEnAPI("", "A").then(redes => {
            if (redes !== undefined) {
                if (redes.REDES !== null && redes.REDES.length > 0) {
                    setTodasLasRedes(redes.REDES)
                }
            }
        })

        GetNextAssistBODepartamentosEnAPI(1000, 1, "A", "", "").then(registro => {
            if (registro !== undefined) {
                if (registro.REGISTROS !== null && registro.REGISTROS.length > 0) {
                    setTodosLosDepartamentos(registro.REGISTROS)
                }
            }
        })


    } else {
        if (!props.ABRIR_FICHA && hayCliente) {
            setTodosLosSocios([])
            setTodasLasRedes([])
            setTodosLosDepartamentos([])
            setCheckedListSocios([])
            setCheckedListRedes([])
            setHayCliente(false);
            setRolesLocal([])
            setTextoIdioma(1)
            setTabPorDefecto("1")
            setIdiomasLocal([])
            setPasswordUsuario("")
            setPayLoadLocal({
                ID: 0,
                NOMBRE: "",
                CORREO_RECUPERACION_PWD: "",
                CORREO_RECEPCION_PEDIDOS: "",
                CORREO_ENVIO_DOCUMENTOS: "",
                USUARIO: "",
                PWD_OLD: "",
                PWD_NEW: "",
                PWD: "",
                OBSERVACIONES: "",
                BAJA: false,
                ID_IDIOMA: "",
                ID_ROL: !"1",
                PERMISO_VONZU: false,
                USUARIO_VONZU: "",
                PWD_VONZU: "",
                DOMINIO_VONZU: "",
                IDS_DEPARTAMENTOS: ""
            })
        }
    }


    const verificarNuevaContraseña = () => {
        let modificarContraseña = passwordUsuario
        let permitirGuardarContraseña = false

        //Si es nuevo usuario
        if (props.ID_USUARIO === -1) {
            permitirGuardarContraseña = true
            setPasswordUsuario(payLoadLocal.PWD_NEW);
            modificarContraseña = payLoadLocal.PWD_NEW;
        } else {
            if (payLoadLocal.PWD_OLD.trim() === "") {
                permitirGuardarContraseña = true
                modificarContraseña = passwordUsuario
            } else {
                if (payLoadLocal.PWD_OLD === modificarContraseña) {
                    if (payLoadLocal.PWD_NEW.trim() !== "") {
                        if (payLoadLocal.PWD_NEW === payLoadLocal.PWD) {

                            permitirGuardarContraseña = true
                            setPasswordUsuario(payLoadLocal.PWD_NEW);
                            modificarContraseña = payLoadLocal.PWD_NEW;
                        } else {
                            MSGERROR(traducirPagina("Msg_nueva_password"))
                        }
                    } else {
                        MSGERROR(traducirPagina("Msg_password_vacio"))
                    }

                } else {
                    MSGERROR(traducirPagina("Msg_no_coincide"))
                }
            }
        }

        return permitirGuardarContraseña
    }


    const modificarUsuario = () => {
        let modificarContraseña = passwordUsuario
        let decidirAccion = props.ID_USUARIO === -1 ? 0 : 1
        let modificarSocio = checkedListSocios.length > 0 ? checkedListSocios.toString() : ""


        //let modificarRedes = checkedListRedes.length > 0 ? checkedListRedes.toString() : ""
        let formatoIdsSocios = modificarSocio.replaceAll(",", ";")

        let IDS_REDES = "";
        if (checkedListRedes.length > 0) {
            let filtroRedes = todasLasRedes.filter((red) => checkedListRedes.includes(`${red.ID}_${red.TIPO}`))
            filtroRedes.map((red, i) => {
                IDS_REDES += `${red.ID}:${red.TIPO};`
            })
        }


        let IDS_DEPARTAMENTOS = "";
        if (checkedListDepartamentos.length > 0) {
            //  let filtroDepa = todosLosDepartamentos.filter((depa) =>  checkedListDepartamentos.includes(depa.ID))
            checkedListDepartamentos.map((registro, i) => {
                IDS_DEPARTAMENTOS += `${registro};`
                /*
                if(i === (checkedListDepartamentos.length-1)){
                    IDS_DEPARTAMENTOS += `${registro}`

                }else{
                    IDS_DEPARTAMENTOS += `${registro};`
                }
                */
            })
        }


        //setPayLoadLocal({...payLoadLocal})



        if (payLoadLocal.PWD_OLD.trim() === "") {
            SetUsuarioEnAPI(payLoadLocal, (props.ID_USUARIO === -1 ? payLoadLocal.PWD_NEW : passwordUsuario), textoIdioma, rolPorDefecto, formatoIdsSocios, decidirAccion, IDS_REDES, IDS_DEPARTAMENTOS).then(usuario => {
                if (usuario.OK) {
                    MSGOK(traducirPagina("Usuario_modificado"))
                    //store.dispatch(DrawerPerfilUsuario(false));
                    //store.dispatch({ type: "STATE_MODIFICAR_EMAIL_ENVIO_DOCUMENTO", emailEnvioDocumento: payLoadLocal.CORREO_ENVIO_DOCUMENTOS })

                    if (props.LLAMADA_DESDE === "FICHA_CLIENTE_TALEER") {
                        props.ACTUALIZAR_LISTA(0, "", "A", 0)
                    }
                }
            })
        } else {
            let permitirGuardarContraseña = verificarNuevaContraseña()
            if (permitirGuardarContraseña) {
                modificarContraseña = payLoadLocal.PWD_NEW;

                let decidirAccion = props.ID_USUARIO === -1 ? 0 : 1
                let modificarSocio = checkedListSocios.length > 0 ? checkedListSocios.toString() : ""
                let formatoIdsSocios = modificarSocio.replaceAll(",", ";")
                SetUsuarioEnAPI(payLoadLocal, modificarContraseña, textoIdioma, rolPorDefecto, formatoIdsSocios, decidirAccion, IDS_REDES, IDS_DEPARTAMENTOS).then(usuario => {
                    if (usuario.OK) {
                        MSGOK(traducirPagina("Usuario_modificado"))
                        // store.dispatch(DrawerPerfilUsuario(false));

                        if (props.LLAMADA_DESDE === "FICHA_CLIENTE_TALEER") {
                            props.ACTUALIZAR_LISTA(0, "", "A", 0)
                        }
                    }
                })
            }
        }


    }



    const guardarEstadoFormulario = (e) => {
        const NOMBRE = e.target.name === 'NOMBRE' ? e.target.value : payLoadLocal.NOMBRE;
        const CORREO_RECUPERACION_PWD = e.target.name === 'CORREO_RECUPERACION_PWD' ? e.target.value : payLoadLocal.CORREO_RECUPERACION_PWD;
        const CORREO_RECEPCION_PEDIDOS = e.target.name === 'CORREO_RECEPCION_PEDIDOS' ? e.target.value : payLoadLocal.CORREO_RECEPCION_PEDIDOS;
        const CORREO_ENVIO_DOCUMENTOS = e.target.name === 'CORREO_ENVIO_DOCUMENTOS' ? e.target.value : payLoadLocal.CORREO_ENVIO_DOCUMENTOS;
        const USUARIO = e.target.name === 'USUARIO' ? e.target.value : payLoadLocal.USUARIO;
        const PWD_OLD = e.target.name === 'PWD_OLD' ? e.target.value : payLoadLocal.PWD_OLD;
        const PWD_NEW = e.target.name === 'PWD_NEW' ? e.target.value : payLoadLocal.PWD_NEW;
        const PWD = e.target.name === 'PWD' ? e.target.value : payLoadLocal.PWD;
        const OBSERVACIONES = e.target.name === 'OBSERVACIONES' ? e.target.value : payLoadLocal.OBSERVACIONES;
        const ID = e.target.name === 'ID' ? e.target.value : payLoadLocal.ID;
        const BAJA = e.target.name === 'BAJA' ? e.target.value : payLoadLocal.BAJA;
        const ID_IDIOMA = e.target.name === 'ID_IDIOMA' ? e.target.value : payLoadLocal.ID_IDIOMA;
        const PERMISO_VONZU = e.target.name === 'PERMISO_VONZU' ? e.target.checked : payLoadLocal.PERMISO_VONZU;
        const USUARIO_VONZU = e.target.name === 'USUARIO_VONZU' ? e.target.value : payLoadLocal.USUARIO_VONZU;
        const PWD_VONZU = e.target.name === 'PWD_VONZU' ? e.target.value : payLoadLocal.PWD_VONZU;
        const DOMINIO_VONZU = e.target.name === 'DOMINIO_VONZU' ? e.target.value : payLoadLocal.DOMINIO_VONZU;


        setPayLoadLocal(
            {
                ID: ID,
                NOMBRE: NOMBRE,
                CORREO_RECUPERACION_PWD: CORREO_RECUPERACION_PWD,
                CORREO_RECEPCION_PEDIDOS: CORREO_RECEPCION_PEDIDOS,
                CORREO_ENVIO_DOCUMENTOS: CORREO_ENVIO_DOCUMENTOS,
                USUARIO: USUARIO,
                PWD_OLD: PWD_OLD,
                PWD_NEW: PWD_NEW,
                PWD: PWD,
                OBSERVACIONES: OBSERVACIONES,
                BAJA: BAJA,
                ID_IDIOMA: ID_IDIOMA,
                PERMISO_VONZU: PERMISO_VONZU,
                USUARIO_VONZU: USUARIO_VONZU,
                PWD_VONZU: PWD_VONZU,
                DOMINIO_VONZU: DOMINIO_VONZU
            }
        )
    }

    const modificarIdioma = (e) => {
        payLoadLocal.ID_IDIOMA = e;
        setPayLoadLocal(payLoadLocal)
        setTextoIdioma(e)
    }

    const modificarRol = (e) => {
        payLoadLocal.ID_ROL = e;
        setPayLoadLocal(payLoadLocal)
        setRolPorDefecto(parseInt(e))
    }


    return (

        <Drawer
            width={props.LLAMADA_DESDE === "FICHA_CLIENTE_TALEER" ? 820 : 600}
            onClose={() => { props.CERRAR_FICHA(false) }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            closable={false}
            bodyStyle={{ padding: '0px' }}
            style={{ color: '#fff' }}>

            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false); }}></CloseOutlined >
                    <div> {props.title}</div>
                </div>

                <div className='itemHeaderDrawer2'>

                </div>
            </div>




            {payLoadLocal === null ?
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h4>{traducirPagina("Info_sin_usuario")}</h4>
                </div>
                :
                <Tabs defaultActiveKey={"1"} activeKey={tabPorDefecto} onChange={(tab) => setTabPorDefecto(tab)}  >
                    <TabPane tab={traducirPagina("Configuracion")} key="1" style={{ marginRight: '5px' }}>
                        <div style={{ height: (configApp.height - 190).toString() + "px", }} className="ml-4 mr-4 mt-4">

                            <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>

                                <Col md={24}>
                                    <span>{`${traducirPagina("Nombre_usuario")}:  `} </span>
                                </Col>
                                <Col md={24} >
                                    <Input name="NOMBRE" value={payLoadLocal.NOMBRE} onChange={(e) => guardarEstadoFormulario(e)} />
                                </Col>

                                <Col md={24}>
                                    <span>{`${traducirPagina("Correo_recuperacion")}:  `} </span>
                                </Col>

                                <Col md={24} >
                                    <Input name="CORREO_RECUPERACION_PWD" value={payLoadLocal.CORREO_RECUPERACION_PWD} onChange={(e) => guardarEstadoFormulario(e)} />
                                </Col>

                                <Col md={24}>
                                    <span>{`${traducirPagina("Seleccione_idioma")}:  `} </span>
                                </Col>
                                {/* ID_IDIOMA */}
                                <Col md={24}>
                                    {idiomasLocal !== null ?
                                        <select value={textoIdioma} className="custom-select" style={{ width: "400px" }}
                                            onChange={(e) => modificarIdioma(e.target.value)}>
                                            {idiomasLocal.length > 0 ?
                                                idiomasLocal.map((idioma) =>
                                                    <option key={idioma.ID} value={idioma.ID}>{idioma.NOMBRE}</option>
                                                )
                                                :
                                                null
                                            }
                                        </select>
                                        :
                                        <div style={{ textAlign: 'center', }}>
                                            <h4>{traducirPagina("Info_error_idioma")}</h4>
                                        </div>
                                    }
                                </Col>

                                <Col md={24}>
                                    <span>{traducirPagina("Seleccione_rol")} </span>
                                </Col>

                                <Col md={24}>
                                    {rolesLocal !== null ?
                                        <select value={rolPorDefecto} className="custom-select" style={{ width: "400px" }}
                                            onChange={(e) => modificarRol(e.target.value)} disabled={esSuperAdmin}>
                                            {rolesLocal.length > 0 ?
                                                rolesLocal.map((idioma) =>
                                                    <option key={idioma.ID} value={idioma.ID}>{idioma.NOMBRE}</option>
                                                )
                                                :
                                                null
                                            }
                                        </select>
                                        :
                                        <div style={{ textAlign: 'center' }}>
                                            <h4>{traducirPagina("Info_error_rol")}</h4>
                                        </div>
                                    }
                                </Col>

                            </Row>
                        </div>

                        <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                            <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                        </div>
                    </TabPane>
                    <TabPane tab={traducirPagina("Credenciales")} key="2" >
                        <div style={{ height: (configApp.height - 203).toString() + "px", }} className="mb-2" >
                            {props.ID_USUARIO === -1 ?
                                <div style={{ height: (configApp.height - 190).toString() + "px", }} className="ml-4 mr-4 mt-4">

                                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>
                                        <Col md={24}>
                                            <span>{`${traducirPagina("Usuario")}:  `} </span>
                                        </Col>
                                        <Col md={24} >
                                            <Input name="USUARIO" value={payLoadLocal.USUARIO} onChange={(e) => guardarEstadoFormulario(e)} />
                                        </Col>

                                        <Col md={24}>
                                            <span>{`${traducirPagina("Contrasenia")}:  `} </span>
                                        </Col>
                                        <Col md={24}>
                                            <Input type="password" name="PWD_NEW" value={payLoadLocal.PWD_NEW} autoComplete="new-password" onChange={(e) => guardarEstadoFormulario(e)} />
                                        </Col>
                                    </Row>
                                </div>
                                :
                                <div style={{ height: (configApp.height - 190).toString() + "px", }} className="ml-4 mr-4 mt-4">

                                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>
                                        <Col md={24}>
                                            <span>{`${traducirPagina("Usuario")}:  `} </span>
                                        </Col>
                                        <Col md={24} >
                                            <Input name="USUARIO" value={payLoadLocal.USUARIO} onChange={(e) => guardarEstadoFormulario(e)} />
                                        </Col>

                                        <Col md={24}>
                                            <span style={{ color: '#999' }}>{`${traducirPagina("Info_usuario")}`} </span>
                                        </Col>

                                        <Col md={24}>
                                            <span>{`${traducirPagina("Contrasenia_actual")}:  `} </span>
                                        </Col>
                                        <Col md={24}>
                                            <Input type="password" name="PWD_OLD" value={payLoadLocal.PWD_OLD} autoComplete="new-password" onChange={(e) => guardarEstadoFormulario(e)} />
                                        </Col>

                                        <Col md={24}>
                                            <span>{`${traducirPagina("Nueva_contrasenia")}:  `} </span>
                                        </Col>
                                        <Col md={24} >
                                            <Input type="password" name="PWD_NEW" value={payLoadLocal.PWD_NEW} autoComplete="new-password" onChange={(e) => { guardarEstadoFormulario(e) }} />
                                        </Col>

                                        <Col md={24}>
                                            <span>{`${traducirPagina("Confirmar_nueva_contrasenia")}:  `} </span>
                                        </Col>
                                        <Col md={24} >
                                            <Input type="password" name="PWD" value={payLoadLocal.PWD} autoComplete="new-password" onChange={(e) => guardarEstadoFormulario(e)} />
                                        </Col>
                                    </Row>

                                </div>
                            }
                        </div>

                        <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                            <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                        </div>
                    </TabPane>

                    <TabPane tab={traducirPagina("Observaciones")} key="3" >

                        <div style={{ height: (configApp.height - 203).toString() + "px", }} className="mb-2" >
                            <div style={{ height: (configApp.height - 190).toString() + "px", }} className="ml-4 mr-4 mt-4" >
                                <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>
                                    <Col md={24}>
                                        <span>{`${traducirPagina("Observaciones")}:  `} </span>
                                    </Col>
                                    <Col md={24} >
                                        <Input.TextArea name="OBSERVACIONES" rows={20} value={payLoadLocal.OBSERVACIONES} onChange={(e) => guardarEstadoFormulario(e)} />
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                            <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                        </div>

                    </TabPane>
                    {/* disabled={rolPorDefecto === 2 ? true : false} */}


                    {props.LLAMADA_DESDE === "FICHA_CLIENTE_TALEER" ?
                        <TabPane tab={traducirPagina("Socios")} key="4" disabled={rolPorDefecto === 2 ? true : false} className="texo_tab_usuario">

                            <div className="mb-2" >
                                <span className="ml-4 mr-4 ">{`${traducirPagina("Numero_socios_seleccionados")}:  ${checkedListSocios.length}`}</span>
                                <div style={{ height: (configApp.height - 215).toString() + "px", overflow: 'auto', overflowX: 'hidden' }} className="ml-4 mr-4 mt-2 mt-4" >
                                    <Checkbox.Group value={checkedListSocios} onChange={(e) => { setCheckedListSocios(e) }}>
                                        {
                                            todosLosSocios.map((row, i) =>
                                                <div key={i}>
                                                    <Checkbox value={row.ID} className="pl-2">{row.NOMBRE_EMPRESA}</Checkbox>
                                                    <br></br>
                                                </div>
                                            )
                                        }
                                    </Checkbox.Group>
                                </div>
                            </div>

                            <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                                <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                            </div>

                        </TabPane>
                        : null
                    }

                    {props.LLAMADA_DESDE === "FICHA_CLIENTE_TALEER" ?
                        <TabPane tab={traducirPagina("Redes")} key="5" disabled={rolPorDefecto === 2 ? true : false} className="texo_tab_usuario">

                            <div className="mb-2" >
                                <span className="ml-4 mr-4 ">{`${traducirPagina("Numero_redes_seleccionados")}:  ${checkedListRedes.length}`}</span>
                                <div style={{ height: (configApp.height - 215).toString() + "px", overflow: 'auto', overflowX: 'hidden' }} className="ml-4 mr-4 mt-2 mt-4" >
                                    <Checkbox.Group value={checkedListRedes} onChange={(e) => { setCheckedListRedes(e) }}>
                                        {
                                            todasLasRedes.map((row, i) =>
                                                <div key={i}>
                                                    <Checkbox value={`${row.ID}_${row.TIPO}`} className=" pl-2">{`[${row.TIPO}] ${row.NOMBRE} [${row.NUMERO_CENTROS}]`}</Checkbox>
                                                    <br></br>
                                                </div>
                                            )
                                        }
                                    </Checkbox.Group>
                                </div>
                            </div>

                            <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                                <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                            </div>

                        </TabPane>
                        : null
                    }


                    {props.LLAMADA_DESDE === "FICHA_CLIENTE_TALEER" ?
                        <TabPane tab={traducirPagina("Departamentos")} key="7" disabled={rolPorDefecto === 2 ? true : false} className="texo_tab_usuario" style={{ marginRight: '5px' }}>

                            <div className="mb-2" >
                                <span className="ml-4 mr-4 ">{`${traducirPagina("Numero_departamentos_seleccionados")}:  ${checkedListDepartamentos.length}`}</span>
                                <div style={{ height: (configApp.height - 215).toString() + "px", overflow: 'auto', overflowX: 'hidden' }} className="ml-4 mr-4 mt-2 mt-4" >
                                    <Checkbox.Group value={checkedListDepartamentos} onChange={(e) => { setCheckedListtDepartamentos(e) }}>
                                        {
                                            todosLosDepartamentos.map((row, i) =>
                                                <div key={i}>
                                                    <Checkbox value={row.ID} className=" pl-2">{`${row.NOMBRE}`}</Checkbox>
                                                    <br></br>
                                                </div>
                                            )
                                        }
                                    </Checkbox.Group>
                                </div>
                            </div>

                            <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                                <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                            </div>

                        </TabPane>
                        : null
                    }


                    {/*disabled={rolPorDefecto === 1 || rolPorDefecto === 2 ? true : false} */}

                    {
                        rolPorDefecto !== 5 ?

                            <TabPane tab={"Vonzu"} key="6" className="texo_tab_usuario">
                                <div style={{ height: (configApp.height - 203).toString() + "px", }} className="mb-2" >
                                    <div style={{ height: (configApp.height - 190).toString() + "px", }} className="ml-4 mr-4 mt-4" >
                                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>

                                            <Col md={24}>
                                                <Checkbox name="PERMISO_VONZU" checked={payLoadLocal.PERMISO_VONZU} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{"Quiero conectarme a la plataforma Vonzu para el tracking de reparto."}</span> </Checkbox>
                                            </Col>

                                            <Col md={24}>
                                                <span>{`${traducirPagina("Dominio")}:  `} </span>
                                            </Col>
                                            <Col md={24} >
                                                <Input disabled={!payLoadLocal.PERMISO_VONZU} name="DOMINIO_VONZU" value={payLoadLocal.DOMINIO_VONZU} onChange={(e) => guardarEstadoFormulario(e)} />
                                            </Col>

                                            <Col md={24}>
                                                <span>{`${traducirPagina("Usuario")}:  `} </span>
                                            </Col>
                                            <Col md={24} >
                                                <Input disabled={!payLoadLocal.PERMISO_VONZU} name="USUARIO_VONZU" value={payLoadLocal.USUARIO_VONZU} onChange={(e) => guardarEstadoFormulario(e)} />
                                            </Col>

                                            <Col md={24}>
                                                <span>{`${traducirPagina("Contrasenia")}:  `} </span>
                                            </Col>
                                            <Col md={24}>
                                                <Input disabled={!payLoadLocal.PERMISO_VONZU} type="password" name="PWD_VONZU" value={payLoadLocal.PWD_VONZU} autoComplete="new-password" onChange={(e) => guardarEstadoFormulario(e)} />
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                                    <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                                </div>

                            </TabPane>
                            :
                            null
                    }

                </Tabs>
            }
        </Drawer >

    )
}

FichaPerfil.propTypes = {
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,

    ID_USUARIO: PropTypes.number,
    LLAMADA_DESDE: PropTypes.string,
    ACTUALIZAR_LISTA: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaPerfil);